import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  ViewUserWalletQuery,
  ViewUserWalletQueryVariables,
} from "../../schemaTypes";

export const viewUserWalletQuery = gql`
  query ViewUserWallet($userId: String!) {
    viewUserWallet(userId: $userId) {
      id
      flId
      flAccountReference
      barterId
      balance
      currency
      flNuban
      bankName
      bankCode
      status
      owner { id }
      createdAt
      updatedAt
    }
  }
`;

export interface WithViewUserWallet {
  wallet: ViewUserWalletQuery["viewUserWallet"] | null;
  loading: boolean;
}

interface Props {
  userId: string;
  children: (data: WithViewUserWallet) => React.ReactElement | null;
}

export const ViewUserWallet: React.FC<Props> = ({ userId, children }) => {
  const { data, loading } = useQuery<ViewUserWalletQuery, ViewUserWalletQueryVariables>(viewUserWalletQuery, {
    variables: { userId }
  });

  let wallet: ViewUserWalletQuery["viewUserWallet"] | null = null;
  if (data && data.viewUserWallet) {
    wallet = data.viewUserWallet;
  }

  return children({
    wallet,
    loading
  });
};